/* =============================================================================
   A2C Overview — page-scoped port of the <script> block in artemis-vite/index.html
   -----------------------------------------------------------------------------
   Isolation notes:
   - Everything lives inside one IIFE. No globals are created except the single
     window.__a2cOverviewBooted guard flag.
   - All DOM lookups are scoped to the section root element, so the code can
     never touch theme markup (header, cart, navigation, forms).
   - Pattern data comes from the Liquid section's blocks via a JSON script tag,
     so the Theme Editor is the single source of truth.
   - Supports Theme Editor section reload/unload and multiple instances.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__a2cOverviewBooted) return;
  window.__a2cOverviewBooted = true;

  /* ---------- constants ported verbatim from the source ---------- */

  /* star positions in viewport-percent coordinates (50,50 = viewport centre) */
  var LAYOUT = [{x:64.8,y:35.8},{x:64.8,y:41.9},{x:78.3,y:47.8},{x:83.4,y:41.4},{x:32.7,y:47.2},{x:86.1,y:32.8},{x:40.4,y:40.5},{x:78.6,y:23.1},{x:17.2,y:49.0},{x:25.6,y:25.2},{x:78.1,y:37.0},{x:46.1,y:26.8},{x:19.3,y:32.1},{x:36.3,y:34.5},{x:67.8,y:47.4},{x:63.7,y:27.8},{x:39.9,y:51.9},{x:51.9,y:22.7},{x:59.6,y:44.5},{x:39.4,y:25.3},{x:42.0,y:32.3},{x:58.1,y:32.8},{x:72.1,y:29.0},{x:47.8,y:37.4},{x:28.1,y:33.7},{x:74.1,y:52.0},{x:88.9,y:49.6},{x:22.1,y:42.6}];
  var PALETTES = {Biodiversity:["#34D6B5","#3FA88F","#A1E3B5","#D9C271","#5FD0E0","#8BC34A"],Humanity:["#F4E6C8","#D6A86A","#9B7BFF","#FFE2B0","#C9B7FF","#FFD580"],Space:["#FFFFFF","#B8C8FF","#7E94FF","#C9A2FF","#E5E2FF"],Other:["#CFD8E3","#6A7CA8","#A6B6C9","#FFFFFF"]};
  var TONE_ACCENT = {alarming:"#E04A2B",urgent:"#FF7A4A",wonder:"#E5E2FF",humorous:"#FFD580",hopeful:"#9DE0C7",calm:null,somber:"#5A6B86"};
  var TONE_MODE = {alarming:"pulse",urgent:"pulse",wonder:"sparkle",humorous:"wave",hopeful:"wave",calm:"fade",somber:"fade"};
  var TONE_BEAT = {alarming:.6,urgent:.55,wonder:1.2,humorous:.8,hopeful:1.1,calm:1.4,somber:1.6};
  var VOTE_KEY = 'overview-pattern-votes';

  /* ---------- helpers ported verbatim ---------- */

  function hashSeed(s){var h=2166136261>>>0;for(var i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619)}return h>>>0}
  function mulberry32(seed){var a=seed>>>0;return function(){a|=0;a=(a+0x6d2b79f5)|0;var t=a;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return((t^(t>>>14))>>>0)/4294967296}}

  function genLights(stat){
    var pal=[].concat(PALETTES[stat.category]||PALETTES.Other);var ac=TONE_ACCENT[stat.tone];if(ac)pal.push(ac);
    var bb=stat.category==="Humanity"?1.8:stat.category==="Biodiversity"?2.6:3.2;
    var bm=TONE_BEAT[stat.tone]||1;var mode=TONE_MODE[stat.tone]||"pulse";
    var rand=mulberry32(hashSeed("artemis:"+stat.id+":"+stat.tone+":"+stat.category));
    return LAYOUT.map(function(pos,i){
      var color=pal[Math.floor(rand()*pal.length)]||pal[0];
      var intensity=Math.max(10,Math.min(100,70+Math.round(rand()*20-10)));
      var beat=Math.max(.2,Math.round(bb*bm*(.7+rand()*.6)*100)/100);
      var delay=Math.round(((i/35)*beat)*100)/100;
      var m=mode;var r=rand();
      if(stat.tone==="alarming"&&r<.12)m="strobe";else if(m!=="sparkle"&&r<.18)m="sparkle";
      return{x:pos.x,y:pos.y,color:color,intensity:intensity,beat:beat,delay:delay,mode:m,id:i+1};
    });
  }

  function fmtVal(raw){var n=Number(String(raw).replace(/,/g,""));if(!isFinite(n)||isNaN(n))return raw;if(Math.abs(n)<1e6)return raw;var f=function(v,s){return parseFloat(v.toFixed(2))+s};if(Math.abs(n)>=1e12)return f(n/1e12,"T");if(Math.abs(n)>=1e9)return f(n/1e9,"B");return f(n/1e6,"M")}
  function fmtCount(n){if(n>=1e12)return(n/1e12).toFixed(2)+"T";if(n>=1e9)return(n/1e9).toFixed(2)+"B";if(n>=1e6)return(n/1e6).toFixed(2)+"M";if(n>=1e3)return Math.round(n).toLocaleString();if(n<1)return n.toFixed(4);return Math.round(n).toLocaleString()}
  function secMid(){var d=new Date();return d.getUTCHours()*3600+d.getUTCMinutes()*60+d.getUTCSeconds()+d.getUTCMilliseconds()/1000}

  /* ADDED: HTML escaping for any text that is injected via innerHTML. The source
     interpolated values directly; values are now Theme Editor input, so they are
     escaped. No visual change for the source content. */
  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function safeParse(text, fallback){
    try { return JSON.parse(text); } catch (e) { return fallback; }
  }

  /* ---------- one instance ---------- */

  function Overview(root){
    var self = this;
    this.root = root;
    this.raf = null;
    this.visible = true;
    this.destroyed = false;
    this.listeners = [];

    var dataEl = root.querySelector('[data-a2c-patterns]');
    this.STATS = dataEl ? safeParse(dataEl.textContent, []) : [];
    if (!this.STATS.length) return;

    /* normalise numeric fields coming from text settings */
    this.STATS.forEach(function(s){
      s.perSecond = (s.perSecond === '' || s.perSecond == null) ? null : Number(s.perSecond);
      s.perDay    = (s.perDay === '' || s.perDay == null) ? null : Number(s.perDay);
      if (s.perSecond !== null && !isFinite(s.perSecond)) s.perSecond = null;
      if (s.perDay !== null && !isFinite(s.perDay)) s.perDay = null;
    });

    this.el = {
      title:    root.querySelector('[data-a2c="title"]'),
      value:    root.querySelector('[data-a2c="value"]'),
      unit:     root.querySelector('[data-a2c="unit"]'),
      live:     root.querySelector('[data-a2c="live"]'),
      perday:   root.querySelector('[data-a2c="perday"]'),
      rate:     root.querySelector('[data-a2c="rate"]'),
      mValue:   root.querySelector('[data-a2c="m-value"]'),
      mLive:    root.querySelector('[data-a2c="m-live"]'),
      mRate:    root.querySelector('[data-a2c="m-rate"]'),
      canvas:   root.querySelector('[data-a2c="canvas"]'),
      voteUp:   root.querySelector('[data-a2c="vote-up"]'),
      voteDown: root.querySelector('[data-a2c="vote-down"]'),
      voteMsg:  root.querySelector('[data-a2c="vote-msg"]'),
      rank:     root.querySelector('[data-a2c="rank"]'),
      share:    root.querySelector('[data-a2c="share"]'),
      pixel:    root.querySelector('[data-a2c="pixel"]'),
      print:    root.querySelector('[data-a2c="print"]'),
      scene:    root.querySelector('.vp-scene'),
      earth:    root.querySelector('.vp-earth'),
      moon:     root.querySelector('.vp-moon')
    };

    var cfgEl = root.querySelector('[data-a2c-config]');
    this.cfg = (cfgEl ? safeParse(cfgEl.textContent, {}) : {}) || {};
    this.votePrompt = this.cfg.votePrompt || 'Cast your vote on this pattern';

    this.userVotes = safeParse(this.readStore(), {}) || {};

    /* default pattern */
    var wanted = this.patternFromUrl() || this.cfg.defaultPatternId;
    var idx = this.indexOfId(wanted);
    this.currentIdx = idx >= 0 ? idx : 0;

    /* catalog buttons are rendered server-side by Liquid (crawlable text);
       here we only attach behaviour. */
    this.statButtons = Array.prototype.slice.call(root.querySelectorAll('[data-a2c-index]'));
    this.statButtons.forEach(function(btn){
      self.on(btn, 'click', function(){ self.renderStat(Number(btn.getAttribute('data-a2c-index'))); });
    });

    if (this.el.voteUp)   this.on(this.el.voteUp,   'click', function(){ self.castVote('up'); });
    if (this.el.voteDown) this.on(this.el.voteDown, 'click', function(){ self.castVote('down'); });
    if (this.el.share)    this.on(this.el.share,    'click', function(){ self.doShare(); });
    if (this.el.pixel)    this.on(this.el.pixel,    'click', function(){ self.doPixel(); });
    if (this.el.print)    this.on(this.el.print,    'click', function(){ self.doPrint(); });

    /* keyboard navigation.
       Source behaviour: ←/→/↑/↓ anywhere cycle topics and preventDefault().
       On a Shopify page that would hijack page scrolling and any theme UI, so it
       is gated: ignored while a form field / contenteditable is focused, while a
       modifier key is held, and while the console is scrolled out of view. */
    this.onKeydown = function(e){
      if (self.destroyed) return;
      if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      var t = e.target;
      if (t && t.closest && t.closest('input,textarea,select,[contenteditable="true"],[role="textbox"]')) return;
      if (!self.visible) return;
      e.preventDefault();
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')  self.renderStat((self.currentIdx - 1 + self.STATS.length) % self.STATS.length);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') self.renderStat((self.currentIdx + 1) % self.STATS.length);
    };
    this.on(document, 'keydown', this.onKeydown);

    this.onHashChange = function(){
      var i = self.indexOfId(self.patternFromUrl());
      if (i >= 0) self.renderStat(i);
    };
    this.on(window, 'hashchange', this.onHashChange);

    /* ADDED (performance, no visual change): pause the per-frame counter while
       the tab is hidden, and track console visibility for the keyboard gate. */
    this.onVisibility = function(){
      if (document.hidden) self.stopTicker();
      else self.startTicker();
    };
    this.on(document, 'visibilitychange', this.onVisibility);

    if (typeof IntersectionObserver === 'function' && this.el.scene){
      this.io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ self.visible = en.isIntersecting; });
      }, {rootMargin: '0px', threshold: 0});
      this.io.observe(this.el.scene);
    }

    this.renderStat(this.currentIdx);
    this.updateRank();
  }

  Overview.prototype.on = function(target, type, fn, opts){
    target.addEventListener(type, fn, opts);
    this.listeners.push([target, type, fn, opts]);
  };

  Overview.prototype.destroy = function(){
    this.destroyed = true;
    this.stopTicker();
    if (this.io) { try { this.io.disconnect(); } catch (e) {} }
    this.listeners.forEach(function(l){ l[0].removeEventListener(l[1], l[2], l[3]); });
    this.listeners = [];
  };

  Overview.prototype.readStore = function(){
    try { return localStorage.getItem(VOTE_KEY) || '{}'; } catch (e) { return '{}'; }
  };
  Overview.prototype.saveVotes = function(){
    try { localStorage.setItem(VOTE_KEY, JSON.stringify(this.userVotes)); } catch (e) {}
  };

  Overview.prototype.indexOfId = function(id){
    if (!id) return -1;
    for (var i = 0; i < this.STATS.length; i++) if (this.STATS[i].id === id) return i;
    return -1;
  };

  Overview.prototype.patternFromUrl = function(){
    var h = (location.hash || '').replace(/^#/, '');
    var m = /(?:^|&)pattern=([\w-]+)/.exec(h);
    if (m) return m[1];
    try { var q = new URLSearchParams(location.search); if (q.get('pattern')) return q.get('pattern'); } catch (e) {}
    return null;
  };
  Overview.prototype.shareUrlFor = function(id){
    try { var u = new URL(location.href); u.hash = 'pattern=' + id; return u.toString(); }
    catch (e) { return location.href.split('#')[0] + '#pattern=' + id; }
  };
  Overview.prototype.shareTextFor = function(s){
    return "I\u2019m exploring Earth through alien-readable light patterns in the Overview Machine. Current pattern: " + s.title + " \u2014 " + s.mainValue + " " + s.unit + ". Would you like this pattern?";
  };

  Overview.prototype.netScore = function(id){
    var v = this.userVotes[id];
    return v === 'up' ? 1 : (v === 'down' ? -1 : 0);
  };

  Overview.prototype.updateVoteUI = function(){
    var id = this.STATS[this.currentIdx].id, v = this.userVotes[id];
    if (this.el.voteUp)   { this.el.voteUp.classList.toggle('selected', v === 'up'); this.el.voteUp.setAttribute('aria-pressed', v === 'up' ? 'true' : 'false'); }
    if (this.el.voteDown) { this.el.voteDown.classList.toggle('selected', v === 'down'); this.el.voteDown.setAttribute('aria-pressed', v === 'down' ? 'true' : 'false'); }
    if (this.el.voteMsg)  this.el.voteMsg.textContent = v === 'up'
      ? "You liked this pattern \u2014 vote recorded"
      : (v === 'down' ? "You disliked this pattern \u2014 vote recorded" : this.votePrompt);
  };

  Overview.prototype.updateRank = function(){
    var self = this, el = this.el.rank;
    if (!el) return;
    var rows = this.STATS.map(function(s){ return {id: s.id, title: s.title, score: self.netScore(s.id)}; });
    rows.sort(function(a, b){ return (b.score - a.score) || a.title.localeCompare(b.title); });
    var voted = rows.filter(function(r){ return r.score !== 0; });
    var list = voted.length ? voted : rows.slice(0, 8);
    var cur = this.STATS[this.currentIdx].id;
    el.innerHTML = list.map(function(r, i){
      var sign = r.score > 0 ? ('+' + r.score) : ('' + r.score);
      var cls = r.score > 0 ? 'pos' : (r.score < 0 ? 'neg' : 'zero');
      return '<li class="rank-row"><button type="button" class="rank-item' + (r.id === cur ? ' active' : '') + '" data-a2c-id="' + esc(r.id) + '">'
           + '<span class="rk-i">' + (i + 1) + '</span>'
           + '<span class="rk-name">' + esc(r.title) + '</span>'
           + '<span class="rk-score ' + cls + '">' + esc(sign) + '</span>'
           + '</button></li>';
    }).join('');
    if (!list.length) el.innerHTML = '<li class="rank-empty">No votes yet \u2014 like a pattern to rank it</li>';
    Array.prototype.forEach.call(el.querySelectorAll('.rank-item'), function(btn){
      btn.addEventListener('click', function(){
        var idx = self.indexOfId(btn.getAttribute('data-a2c-id'));
        if (idx >= 0) self.renderStat(idx);
      });
    });
  };

  Overview.prototype.castVote = function(dir){
    var id = this.STATS[this.currentIdx].id;
    this.userVotes[id] = (this.userVotes[id] === dir) ? null : dir;
    if (this.userVotes[id] == null) delete this.userVotes[id];
    this.saveVotes();
    this.updateVoteUI();
    this.updateRank();
  };

  Overview.prototype.renderLightsInto = function(el, stat){
    if (!el) return;
    el.innerHTML = '';
    genLights(stat).forEach(function(l){
      var sz = Math.round(5 + (l.intensity / 100) * 9);
      var dot = document.createElement('div');
      dot.className = 'lp mode-' + l.mode;
      dot.style.cssText = 'left:' + l.x + '%;top:' + l.y + '%;width:' + sz + 'px;height:' + sz + 'px;color:' + l.color + ';background:' + l.color + ';box-shadow:0 0 8px ' + l.color + ',0 0 18px ' + l.color + ';opacity:1;visibility:visible;z-index:2;--a2c-beat:' + l.beat + 's;--a2c-delay:-' + l.delay + 's';
      dot.innerHTML = '<div class="core"></div><div class="glow"></div>';
      el.appendChild(dot);
    });
  };

  Overview.prototype.stopTicker = function(){
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
  };

  Overview.prototype.startTicker = function(){
    var self = this;
    this.stopTicker();
    if (this.destroyed || document.hidden) return;
    var s = this.STATS[this.currentIdx];
    if (!s || !s.perSecond) return;
    var base = secMid() * s.perSecond, t0 = performance.now();
    function tick(){
      if (self.destroyed) return;
      var c = fmtCount(base + (performance.now() - t0) / 1000 * s.perSecond);
      if (self.el.live)  self.el.live.textContent = c;
      if (self.el.mLive) self.el.mLive.textContent = c;
      self.raf = requestAnimationFrame(tick);
    }
    this.raf = requestAnimationFrame(tick);
  };

  Overview.prototype.renderStat = function(idx){
    this.stopTicker();
    this.currentIdx = idx;
    var s = this.STATS[idx];
    if (!s) return;
    if (this.el.title)  this.el.title.textContent = s.title;
    if (this.el.value)  this.el.value.textContent = fmtVal(s.mainValue);
    if (this.el.unit)   this.el.unit.textContent = s.unit;
    if (this.el.mValue) this.el.mValue.textContent = fmtVal(s.mainValue);
    if (this.el.mRate)  this.el.mRate.textContent = s.cadenceLabel || "\u2014";
    this.renderLightsInto(this.el.canvas, s);

    if (s.perSecond) {
      if (this.el.perday) this.el.perday.textContent = fmtCount(s.perDay);
      if (this.el.rate)   this.el.rate.textContent = s.cadenceLabel;
      this.startTicker();
    } else {
      if (this.el.live)   this.el.live.textContent = "\u2014";
      if (this.el.mLive)  this.el.mLive.textContent = "\u2014";
      if (this.el.perday) this.el.perday.textContent = s.cadenceLabel || "\u2014";
      if (this.el.rate)   this.el.rate.textContent = "static";
    }
    this.updateVoteUI();
    for (var i = 0; i < this.statButtons.length; i++) {
      var on = Number(this.statButtons[i].getAttribute('data-a2c-index')) === idx;
      this.statButtons[i].classList.toggle('active', on);
      this.statButtons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  };

  Overview.prototype.doShare = function(){
    var s = this.STATS[this.currentIdx];
    var url = this.shareUrlFor(s.id), text = this.shareTextFor(s), msg = this.el.voteMsg;
    if (navigator.share) {
      navigator.share({title: "Overview Effect \u2014 " + s.title, text: text, url: url})
        .then(function(){ if (msg) msg.textContent = "Shared"; })
        .catch(function(){});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text + " " + url)
        .then(function(){ if (msg) msg.textContent = "Share link copied to clipboard"; })
        .catch(function(){ window.prompt("Copy this share link:", text + " " + url); });
    } else {
      window.prompt("Copy this share link:", text + " " + url);
    }
  };

  Overview.prototype.buildPattern = function(s){
    var lights = genLights(s), palette = [];
    var pts = lights.map(function(l){
      if (palette.indexOf(l.color) < 0) palette.push(l.color);
      return {x: Math.round(l.x * 100) / 100, y: Math.round(l.y * 100) / 100,
              size: Math.round(5 + (l.intensity / 100) * 9), color: l.color,
              intensity: Math.round(l.intensity) / 100};
    });
    return {id: s.id, title: s.title,
      description: "Alien-readable light pattern for the " + s.title + " topic in the Overview Machine.",
      stats: {main: s.mainValue, unit: s.unit, cadence: s.cadenceLabel},
      palette: palette, points: pts,
      pixelblaze: {coordinateSpace: "percent-0-100", pixelCount: pts.length,
        note: "Map each point x/y to your LED layout; drive each pixel with its color at the given intensity (0-1)."}};
  };

  Overview.prototype.doPixel = function(){
    var s = this.STATS[this.currentIdx], data = this.buildPattern(s), msg = this.el.voteMsg;
    var blob = new Blob([JSON.stringify(data, null, 2)], {type: 'application/json'});
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = s.id + '-pattern.json';
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 120);
    if (msg) msg.textContent = 'Pixelblaze JSON downloaded';
  };

  Overview.prototype.pdfFallback = function(s){
    return {
      title: (s.title || '').toUpperCase(),
      subtitle: (s.short || '').split('. ')[0].replace(/\.$/, ''),
      stats: [
        {v: s.mainValue, l: s.unit},
        {v: (s.perDay != null ? Number(s.perDay).toLocaleString() : "\u2014"), l: 'Per day'},
        {v: s.cadenceLabel, l: 'Real-time cadence'}
      ],
      desc: s.short,
      source: s.source
    };
  };

  Overview.prototype.pdfContentFor = function(s){
    var fb = this.pdfFallback(s), p = s.pdf || {};
    var st = [];
    for (var i = 0; i < 3; i++) {
      var v = p.stats && p.stats[i] ? p.stats[i].v : '';
      var l = p.stats && p.stats[i] ? p.stats[i].l : '';
      st.push({v: v !== '' ? v : fb.stats[i].v, l: l !== '' ? l : fb.stats[i].l});
    }
    return {
      title:    p.title    ? p.title    : fb.title,
      subtitle: p.subtitle ? p.subtitle : fb.subtitle,
      stats:    st,
      desc:     p.desc     ? p.desc     : fb.desc,
      source:   p.source   ? p.source   : fb.source
    };
  };

  Overview.prototype.doPrint = function(){
    var root = this.root, s = this.STATS[this.currentIdx];
    var c = this.pdfContentFor(s);
    var lights = genLights(s), dotsHtml = '';
    lights.forEach(function(l){
      var sz = Math.round(4 + (l.intensity / 100) * 7);
      dotsHtml += '<div class="lp" style="left:' + l.x + '%;top:' + l.y + '%;width:' + sz + 'px;height:' + sz + 'px;color:' + l.color + ';background:' + l.color + ';box-shadow:0 0 5px ' + l.color + ',0 0 12px ' + l.color + ';opacity:' + (l.intensity / 100) + ';"><div class="core"></div><div class="glow"></div></div>';
    });
    var statsHtml = c.stats.map(function(st){
      return '<div class="pp-stat"><div class="v">' + esc(st.v) + '</div><div class="l">' + esc(st.l) + '</div></div>';
    }).join('');

    var exploreLabel = this.cfg.pdfExploreLabel || '';
    var exploreUrl = this.cfg.pdfExploreUrl || '';
    var exploreHtml = '';
    if (exploreLabel) {
      exploreHtml = exploreUrl
        ? '<a class="pp-explore" href="' + esc(exploreUrl) + '">' + esc(exploreLabel) + '</a>'
        : '<span class="pp-explore">' + esc(exploreLabel) + '</span>';
    }

    var host = document.createElement('div');
    host.className = 'a2c-print-host';
    host.setAttribute('aria-hidden', 'true');

    /* carry the image URLs across: the print host lives on <body>, outside the
       page wrapper, so it does not inherit the wrapper's custom properties. */
    var cs = window.getComputedStyle(root);
    var earthUrl = (cs.getPropertyValue('--a2c-earth-url') || '').trim();
    var moonUrl  = (cs.getPropertyValue('--a2c-moon-url')  || '').trim();
    if (earthUrl) host.style.setProperty('--a2c-earth-url', earthUrl);
    if (moonUrl)  host.style.setProperty('--a2c-moon-url', moonUrl);

    var frameSrc = root.getAttribute('data-a2c-frame') || '';

    host.innerHTML = '<div class="print-page">'
      + '<div class="pp-sky"><div class="pp-stars"></div></div>'
      + '<div class="pp-streaks"></div>'
      + '<div class="pp-brand">' + esc(this.cfg.pdfBrand || 'Overview Effect') + '</div>'
      + '<div class="pp-frame"><div class="pp-backing"></div><div class="pp-scene"><div class="pp-moon"></div><div class="pp-dots">' + dotsHtml + '</div><div class="pp-earth"></div></div><img class="pp-img" src="' + esc(frameSrc) + '" alt=""/></div>'
      + '<div class="pp-rule"></div>'
      + '<div class="pp-data"><div class="pp-cat">' + esc(s.category || 'Earth Pattern') + '</div>'
      + '<div class="pp-title">' + esc(c.title) + '</div>'
      + '<div class="pp-sub">' + esc(c.subtitle) + '</div>'
      + '<div class="pp-stats">' + statsHtml + '</div>'
      + '<div class="pp-desc">' + esc(c.desc) + '</div>'
      + exploreHtml
      + '<div class="pp-source"><strong>Source:</strong> ' + esc(c.source) + '</div>'
      + '<div class="pp-foot">' + esc(this.cfg.pdfFooter || '') + '</div></div>'
      + '</div>';

    /* belt-and-braces: copy the resolved background images off the live scene,
       exactly as the source did, in case the custom properties are unavailable */
    try {
  var ppEarth = host.querySelector('.pp-earth');
  var ppMoon = host.querySelector('.pp-moon');

  if (this.el.earth && ppEarth) {
    var earthSrc = this.el.earth.currentSrc || this.el.earth.src || '';

    if (earthSrc) {
      var earthImg = document.createElement('img');
      earthImg.src = earthSrc;
      earthImg.alt = '';
      earthImg.style.cssText =
        'position:absolute;' +
        'inset:0;' +
        'width:100%;' +
        'height:100%;' +
        'display:block;' +
        'object-fit:cover;' +
        'border-radius:50%;';

      ppEarth.style.backgroundImage = 'none';
      ppEarth.innerHTML = '';
      ppEarth.appendChild(earthImg);
    }
  }

  if (this.el.moon && ppMoon) {
    var moonSrc = this.el.moon.currentSrc || this.el.moon.src || '';

    if (moonSrc) {
      var moonImg = document.createElement('img');
      moonImg.src = moonSrc;
      moonImg.alt = '';
      moonImg.style.cssText =
        'position:absolute;' +
        'inset:0;' +
        'width:100%;' +
        'height:100%;' +
        'display:block;' +
        'object-fit:cover;' +
        'object-position:center bottom;';

      ppMoon.style.backgroundImage = 'none';
      ppMoon.innerHTML = '';
      ppMoon.appendChild(moonImg);
    }
  }
} catch (e) {}

    document.body.appendChild(host);

    var cleaned = false;
    function cleanup(){
      if (cleaned) return;
      cleaned = true;
      window.removeEventListener('afterprint', cleanup);
      if (host.parentNode) host.parentNode.removeChild(host);
    }
    window.addEventListener('afterprint', cleanup);
    setTimeout(function(){
      try { window.print(); } catch (e) {}
      setTimeout(cleanup, 5000);
    }, 160);
  };

  /* ---------- boot / Theme Editor lifecycle ---------- */

  var instances = {};

  function boot(scope){
    var roots = (scope || document).querySelectorAll('[data-a2c-overview]');
    Array.prototype.forEach.call(roots, function(root){
      var key = root.getAttribute('data-a2c-overview');
      if (instances[key]) instances[key].destroy();
      instances[key] = new Overview(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  document.addEventListener('shopify:section:unload', function(e){
    var roots = e.target.querySelectorAll ? e.target.querySelectorAll('[data-a2c-overview]') : [];
    Array.prototype.forEach.call(roots, function(root){
      var key = root.getAttribute('data-a2c-overview');
      if (instances[key]) { instances[key].destroy(); delete instances[key]; }
    });
  });
})();
